export type PasswordCapability = { canChange: boolean; reason?: "telegram" | "unconfigured" };
export type PasswordChangeInput = { currentPassword: string; newPassword: string; confirmPassword: string };
export const newPasswordHint = "8–128 位，同时包含字母和数字。";

export function passwordChangeErrors(input: PasswordChangeInput) {
  const errors: Partial<Record<keyof PasswordChangeInput, string>> = {};
  if (!input.currentPassword || input.currentPassword.length > 128) errors.currentPassword = "请输入当前密码（最多 128 位）。";
  if (input.newPassword.length < 8 || input.newPassword.length > 128 || !/[A-Za-z]/.test(input.newPassword) || !/\d/.test(input.newPassword)) errors.newPassword = `新密码须为 ${newPasswordHint}`;
  else if (input.newPassword === input.currentPassword) errors.newPassword = "新密码不能与当前密码相同。";
  if (input.confirmPassword !== input.newPassword || !input.confirmPassword) errors.confirmPassword = "两次输入的新密码不一致。";
  return errors;
}
